import { FacadeService } from "src/app/shared/service-facade/facade.service";
import { DefaultRulesService } from "./default-rules.service"
import { BaskRulesService } from "./bask-rules.service"
import {PageBreakRules} from "./page-break-rules.abstract";

export function PageBreakRulesFactory(facade: FacadeService): PageBreakRules {
  if (facade.isBaskBrand()) {
    return new BaskRulesService();
  }

  return new DefaultRulesService();
}
